<template>
  <div class="subexercise">
    <h1 v-if="loaded">{{exercise.title}} {{subid + 1}}</h1>
    <subexercise
      v-if="loaded"
      :exercise="subexercise" 
      :index="subid">
    </subexercise>
  </div>
</template>

<script>
import view from '../mixins/view'
import { getExercise } from '../vuex/exercises/actions'
import { activeExercise } from '../vuex/exercises/getters'
import Subexercise from 'components/SubExercise.vue'
export default {
  name: 'SubexerciseView',
  mixins: [view],
  components: {
    Subexercise
  },
  data () {
    return {
      loaded: false
    }
  },
  computed: {
    id () {
      return parseInt(this.$route.params.id)
    },
    subid () {
      return parseInt(this.$route.params.subid)
    },
    subexercise () {
      return this.exercise && this.exercise.exercises[this.subid]
    }
  },
  vuex: {
    getters: {
      exercise: activeExercise
    },
    actions: {
      getExercise
    }
  },
  ready () {
    this.getExercise(this.id).then(response => {
      this.loaded = true
    })
  }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// SubexerciseView.vue?4baf457a